<template>
  <div class="p-capture">
    <div class="p-capture-tabMenu">
      <TwoTabsMenu @click="handleTabMenu" :createThumbnailBy="createThumbnailBy"></TwoTabsMenu>
    </div>
    <div class="p-capture-tabContents">
      <div class="p-capture-tabContents__form">
        <TabContentsImgType></TabContentsImgType>
      </div>
      <div class="p-capture-tabContents__form">
        <TabContentsCaptureUrlForm
          v-if="createThumbnailBy === 'url'"
          @capture="capture"
          :errorAxios="errorAxios"
        >
        </TabContentsCaptureUrlForm>
        <TabContentsCaptureImgForm
          v-else
          @capture="capture">
        </TabContentsCaptureImgForm>
      </div>
    </div>
  </div>
</template>

<script>
import Store from '../../store/index.js'
import TwoTabsMenu from '@/components/modules/TwoTabsMenu.vue'
import TabContentsImgType from '@/components/modules/TabContentsImgType'
import TabContentsCaptureUrlForm from '@/components/modules/TabContentsCaptureUrlForm.vue'
import TabContentsCaptureImgForm from '@/components/modules/TabContentsCaptureImgForm.vue'

export default {
  components: {
    TwoTabsMenu,
    TabContentsImgType,
    TabContentsCaptureUrlForm,
    TabContentsCaptureImgForm
  },
  props: {
    bgColor: String,
    createThumbnailBy: String,
    fileNamePC: String,
    fileNameSP: String,
    errorAxios: Object
  },
  methods: {
    handleTabMenu () {
      Store.commit('handleTabMenu')
    },
    capture (e) {
      this.$emit('capture', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-capture {

  &-tabMenu{
    height: 50px;
  }

  &-tabContents {
    width: 800/1280*100vw;
    margin-top: 20px;
    padding: 20px 30/1280*100vw;
    background: $color_white;
    border-radius: 15px;
    box-sizing: border-box;
    box-shadow: $bs-default;

    @include media-queries-sp {
      width: 100%;
    }
    &__intro {
      display: flex;
      justify-content: space-between;
      &--ex {
        width: 200/1280*100vw;
        min-width: 178px;
        margin-right: 45/1280*100vw;
      }

      &--disc {
        width: 515/1280*100vw;
      }
    }
  }
}
</style>
